import React from "react";

/**
 * DogBotIcon — Cute Shiba Inu style dog with headphones.
 * Transparent background — the button provides the backdrop.
 */
const DogBotIcon = ({ size = 64, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="furMain" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#F97316" />
        <stop offset="100%" stopColor="#EA580C" />
      </linearGradient>
      <linearGradient id="furTop" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#FB923C" />
        <stop offset="100%" stopColor="#F97316" />
      </linearGradient>
      <radialGradient id="eyeGrad" cx="40%" cy="30%" r="60%">
        <stop offset="0%" stopColor="#6B3A2A" />
        <stop offset="100%" stopColor="#3B1A0E" />
      </radialGradient>
      <linearGradient id="hpBand" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#7C3AED" />
        <stop offset="100%" stopColor="#A855F7" />
      </linearGradient>
      <linearGradient id="hpCup" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#14B8A6" />
        <stop offset="100%" stopColor="#0D9488" />
      </linearGradient>
    </defs>

    {/* ── Pointy ears (Shiba style) ── */}
    {/* Left ear outer */}
    <path d="M10 32 L13 12 L26 26 Z" fill="url(#furMain)" />
    {/* Left ear inner pink */}
    <path d="M13 28 L15 16 L23 26 Z" fill="#FDA4AF" opacity="0.85" />
    {/* Right ear outer */}
    <path d="M54 32 L51 12 L38 26 Z" fill="url(#furMain)" />
    {/* Right ear inner pink */}
    <path d="M51 28 L49 16 L41 26 Z" fill="#FDA4AF" opacity="0.85" />

    {/* ── Headphone band ── */}
    <path
      d="M12 33 C12 12 52 12 52 33"
      stroke="url(#hpBand)"
      strokeWidth="4"
      strokeLinecap="round"
      fill="none"
    />

    {/* ── Left headphone cup ── */}
    <ellipse cx="11" cy="35" rx="6" ry="7" fill="url(#hpCup)" />
    <ellipse cx="11" cy="35" rx="4" ry="5" fill="#2DD4BF" />
    <ellipse cx="10.5" cy="33.5" rx="1.5" ry="2" fill="white" opacity="0.3" />

    {/* ── Right headphone cup ── */}
    <ellipse cx="53" cy="35" rx="6" ry="7" fill="url(#hpCup)" />
    <ellipse cx="53" cy="35" rx="4" ry="5" fill="#2DD4BF" />
    <ellipse cx="52.5" cy="33.5" rx="1.5" ry="2" fill="white" opacity="0.3" />

    {/* ── Dog head ── */}
    {/* Main head shape */}
    <ellipse cx="32" cy="38" rx="19" ry="18" fill="url(#furTop)" />
    {/* Forehead lighter */}
    <ellipse cx="32" cy="30" rx="15" ry="10" fill="#FB923C" />

    {/* ── White muzzle (Shiba style) ── */}
    <ellipse cx="32" cy="46" rx="11" ry="8" fill="white" opacity="0.95" />
    {/* Muzzle top blend */}
    <ellipse cx="32" cy="43" rx="10" ry="6" fill="white" opacity="0.7" />



    {/* ── Eyes ── */}
    {/* Left eye white */}
    <circle cx="24" cy="36" r="6" fill="white" />
    {/* Left iris */}
    <circle cx="24" cy="36" r="4.2" fill="url(#eyeGrad)" />
    {/* Left pupil */}
    <circle cx="24" cy="36" r="2.5" fill="#1A0800" />
    {/* Left shine large */}
    <circle cx="25.8" cy="34" r="1.8" fill="white" />
    {/* Left shine small */}
    <circle cx="22.5" cy="37.8" r="0.8" fill="white" opacity="0.6" />

    {/* Right eye white */}
    <circle cx="40" cy="36" r="6" fill="white" />
    {/* Right iris */}
    <circle cx="40" cy="36" r="4.2" fill="url(#eyeGrad)" />
    {/* Right pupil */}
    <circle cx="40" cy="36" r="2.5" fill="#1A0800" />
    {/* Right shine large */}
    <circle cx="41.8" cy="34" r="1.8" fill="white" />
    {/* Right shine small */}
    <circle cx="38.5" cy="37.8" r="0.8" fill="white" opacity="0.6" />

    {/* ── Nose ── */}
    <ellipse cx="32" cy="43" rx="3.5" ry="2.5" fill="#1A0800" />
    <ellipse cx="31" cy="42.2" rx="1.3" ry="0.9" fill="white" opacity="0.45" />

    {/* ── Open happy mouth ── */}
    <path
      d="M26 46.5 Q32 52 38 46.5"
      stroke="#C2410C"
      strokeWidth="1.8"
      strokeLinecap="round"
      fill="none"
    />
    {/* Tongue */}
    <ellipse cx="32" cy="50" rx="4" ry="3.2" fill="#F9A8D4" />
    <ellipse cx="32" cy="48.5" rx="4" ry="1.8" fill="#FCA5A5" />
    <line x1="32" y1="48" x2="32" y2="53" stroke="#F472B6" strokeWidth="1.2" strokeOpacity="0.6" />



    {/* ── Eyebrows ── */}
    <path d="M19.5 31 Q24 28.5 28 31" stroke="#C2410C" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.8" />
    <path d="M36 31 Q40 28.5 44.5 31" stroke="#C2410C" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.8" />

  </svg>
);

export default DogBotIcon;
